import React from "react";
import TopBar from "./TopBar";
import { withRouter } from "react-router-dom";
import SecurityService from "../../../../services/SecurityService";
import UserSession from "../../../../session/UserSession";
import { paths } from "../../../paths";
import PageComponent from "../PageComponent";

class TopBarContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.securityService = new SecurityService();

    this.state = {
      user: null
    };
  }

  getComponentTitle = () => {
    return undefined;
  };

  componentDidMount() {
    this.refreshUserData();
  }

  refreshUserData = () => {
    const user = UserSession.getUser();
    this.setState({ user: user });
  };

  logout = () => {
    this.prepareCall(this.securityService.logout(this.onLogout));
    this.performCalls();
  };

  onLogout = () => {
    UserSession.deleteUserSession();
    this.changePath(paths.LOGIN_PATH);
  };

  render() {
    return (
      <TopBar
        user={this.state.user}
        onLogout={this.logout}
        refresh={this.refreshUserData}
        breadcrumbsRef={this.props.breadcrumbsRef}
        onBreadcrumbClick={this.props.onBreadcrumbClick}
        messageHandler={this.messageHandler}
      />
    );
  }
}

export default withRouter(TopBarContainer);
